import { gql } from "@apollo/client";

export const FETCH_ODOO_PRODUCT_COST = gql`
  query FETCH_ODOO_PRODUCT_COST($instance: String!, $ids: [Int!]!) {
    odooProducts(
      instance: $instance
      ids: $ids
      fields: ["standard_price", "cost_currency_id"]
    )
    odooActiveCurrencies(company: "AB")
  }
`;
